import PropTypes from 'prop-types';
import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux'

import ClientDataStepSimple from './ClientDataStepSimple'
import SimpleSummary from './SimpleSummary'
import Button from '../../components/navigation/Button'

import * as StepLabels from '../../constants/StepLabels'

import AppPreloader from '../../components/AppPreloader'
import FloatWrapper from "../../components/FloatWrapper";
import {initializeAppSimple} from "../../actions/AppInit.Simple";
import {forceValidationOnSteps} from "../../actions/StepControl";
import {querySimpleCartCheckout} from "../../actions/Cart";
import {isClientDataStepValid, isSimpleSummaryValid} from "../../selectors/StepValidation";
import {getBaseArticlePrice, getMainArticleInCart} from "../../selectors/Cart";
import {showPopupWithIframe} from "../../actions/Popup";
import {_orderCta} from "../../selectors/GetParam";
import {TermsText} from "../../components/summary/TermsText";

class SimpleCheckout extends Component {


    static propTypes = {
        baseArticleId: PropTypes.string.isRequired,
        initialCartId: PropTypes.string,
        initParams: PropTypes.object,
        appInitialized: PropTypes.bool
    }

    static defaultProps = {
        initialArticles: [],
        initialPromotionCode: ''
    }

    handleButtonNextClick = () => {

        if (!this.props.clientDataStepValid) {
            this.props.forceFormValidation()
        }

        if (!this.props.simpleSummaryValid) {
            this.props.forceFormValidation()
        }

        if (this.props.clientDataStepValid && this.props.simpleSummaryValid) {
            this.props.querySimpleCheckout()
        }

    }

    componentDidMount() {

        if (this.props.baseArticleId) {
            this.props.initializeAppSimple(this.props.baseArticleId, this.props.initParams)
        }

    }

    render() {

        if (!this.props.appInitialized) {
            return (
                <AppPreloader label=""/>
            )
        }

        const validationError =
            (this.props.forcedValidationSteps.includes(StepLabels.STANDALONE) && (!this.props.clientDataStepValid || !this.props.simpleSummaryValid)) ?
                <div className="simple-summary-error">
                    Bitte überprüfe deine Eingaben!
                </div>
                : null

        const ctaLabel = _orderCta ? _orderCta : this.props.baseArticlePrice > 0 ? "Jetzt kostenpflichtig bestellen" : "Jetzt bestellen";
        const orderCtaDisabled = this.props.existingCustomerSelected && !this.props.isAuthenticatedUser;

        return (
            <div className="simple-wrapper">
                {(this.props.orderComplete) ? <div className="mouse-block"></div> : null}
                {this.props.children}
                <div>
                    <div>
                        <ClientDataStepSimple/>
                    </div>
                    <div>
                        {this.props.baseArticlePrice > 0 ? <SimpleSummary/> : null}
                        {validationError}
                        <div className="summary-step__agb">
                            <TermsText article={this.props.mainArticleInCart} label={ctaLabel}/>
                        </div>
                        <FloatWrapper>
                            <Button
                                onClick={!orderCtaDisabled ? this.handleButtonNextClick : null}
                                disabled={orderCtaDisabled}
                                label={ctaLabel}
                                boldFont={true}
                            />
                        </FloatWrapper>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps) => {

    return {
        isAuthenticatedUser: state.clientDataStep.clientData !== false,
        existingCustomerSelected: state.clientDataStep.existingCustomerSelected,
        appInitialized: state.appState.isInitialized,
        clientDataStepValid: isClientDataStepValid(state),
        simpleSummaryValid: isSimpleSummaryValid(state),
        isFetchingFormData: state.appState.isFetchingFormData,
        isFetchingClientData: state.clientDataStep.isFetchingClientData,
        forcedValidationSteps: state.ui.forcedValidationSteps,
        orderComplete: state.appState.orderComplete,
        baseArticlePrice: getBaseArticlePrice(state),
        mainArticleInCart: getMainArticleInCart(state)
    }

}

const mapDispatchToProps = (dispatch) => {

    return {
        initializeAppSimple: (baseArticleId, initParams) => {
            dispatch(initializeAppSimple(baseArticleId, initParams))
        },
        forceFormValidation: () => {
            dispatch(forceValidationOnSteps([StepLabels.STANDALONE]))
        },
        querySimpleCheckout: () => {
            dispatch(querySimpleCartCheckout())
        },
        showAGBPopup: () => {
            dispatch(showPopupWithIframe('https://www.mittwald.de/bestellung/popups/agb'))
        },
        showPolicyPopup: () => {
            dispatch(showPopupWithIframe('https://www.mittwald.de/bestellung/popups/datenschutz'))
        },
        showRepealPopup: () => {
            dispatch(showPopupWithIframe('https://www.mittwald.de/bestellung/popups/agb#widerrufsbelehrung'))
        },
        showIFramePopup: (src) => {
            dispatch(showPopupWithIframe(src))
        }
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(SimpleCheckout)



/** WEBPACK FOOTER **
 ** ./src/containers/clientdatasimple/SimpleCheckout.js
 **/